import { Coupon } from "./Coupon";
export default Coupon